import {
  BrowseViewResponseDto,
  ApiError,
  ErrorResponseDto,
  BrowseViewState,
} from '@pro4-erp/core-web';
import env from '@/env';
import { ClientVisit } from '../types';

export const getOpenedClientVisitsForMe = async ({
  page,
  pageSize,
  search,
  sortBy,
  lang = '',
}: BrowseViewState & { lang?: string }): Promise<BrowseViewResponseDto<ClientVisit>> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/client-visits/me/opened?${new URLSearchParams({
      page: page.toString(),
      pageSize: pageSize.toString(),
      search: search.toString(),
      sortBy: sortBy ? JSON.stringify(sortBy) : '',
      lang,
    })}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }
  const response = (await fetchResponse.json()) as BrowseViewResponseDto<ClientVisit>;
  return response;
};
